export default __webpack_public_path__ + "static/cocuk-oksuruk-big-071d6c2ff44627fcd6322a0f70213051.webp";